<div class="center" *ngIf="loading" style="margin-top: 40px;">
  <mat-spinner [diameter]="25"></mat-spinner>
  <p style="margin-right: 16px;">در حال بارگذاری...</p>
</div>

<ng-container *ngIf="!loading">
  <div class="row-center">
    <h3>زیر مجموعه‌ها</h3>
    <div class="flex"></div>
    <button (click)="addUser()" mat-flat-button color="primary">
      <mat-icon>add</mat-icon>ثبت زیرمجموعه جدید
    </button>
  </div>

  <div style="overflow-x: auto;background-color: white;" class="column">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <!-- use a disabled button to provide padding for tree leaf -->
        <button mat-icon-button disabled></button>
        <div class="row-center flex">
          <img class="img" [src]="node.picture" alt="">
          <div class="name">
            {{node.name + ' '+ node.family}}
          </div>
          <div class="code">
            کد :
            {{node.code}}
          </div>
          <div class="score">
            امتیاز :
            {{node.score||0}} از 5
          </div>
          <div class="flex row">
            <button matTooltip="ویرایش اطلاعات" (click)="editUser(node)" mat-icon-button>
              <mat-icon>edit</mat-icon>
            </button>
            <!-- <button matTooltip="افزودن زیرمجموعه" (click)="addUser(node)" mat-icon-button>
              <mat-icon>add</mat-icon>
            </button> -->
            <!-- <button matTooltip="حذف کاربر" (click)="deleteUser(node)" mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button> -->
            <button *ngIf="node.roleId===2" matTooltip="امتیاز دادن" (click)="openScoreDialog(node)" mat-icon-button>
              <mat-icon>star_border</mat-icon>
            </button>
            <button [matMenuTriggerFor]="menu" matTooltip="مشاهده آگهی‌ها" mat-icon-button>
              <mat-icon>all_inbox</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button (click)="openPost('free',node)" mat-menu-item>رایگان </button>
              <button (click)="openPost('pro',node)" mat-menu-item>ویژه</button>
              <button (click)="openPost('expire',node)" mat-menu-item>منقضی</button>
            </mat-menu>
          </div>
        </div>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <div class="row-center flex">
          <img class="img" [src]="node.picture" alt="">
          <div class="name">
            {{node.name + ' '+ node.family}}
          </div>
          <div class="code">
            کد :
            {{node.code}}
          </div>
          <div class="score">
            امتیاز :
            {{node.score||0}} از 5
          </div>
          <div class="flex row">
            <button matTooltip="ویرایش اطلاعات" (click)="editUser(node)" mat-icon-button>
              <mat-icon>edit</mat-icon>
            </button>
            <button matTooltip="افزودن زیرمجموعه" *ngIf="node.roleId >2" (click)="addUser(node)" mat-icon-button>
              <mat-icon>add</mat-icon>
            </button>
            <!-- <button matTooltip="حذف کاربر" (click)="deleteUser(node)" mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button> -->
            <button *ngIf="node.roleId===2" matTooltip="امتیاز دادن" (click)="openScoreDialog(node)" mat-icon-button>
              <mat-icon>star_border</mat-icon>
            </button>
            <button [matMenuTriggerFor]="menu" matTooltip="مشاهده آگهی‌ها" mat-icon-button>
              <mat-icon>all_inbox</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button (click)="openPost('free',node)" mat-menu-item>رایگان </button>
              <button (click)="openPost('pro',node)" mat-menu-item>ویژه</button>
              <button (click)="openPost('expire',node)" mat-menu-item>منقضی</button>
            </mat-menu>
          </div>
        </div>
      </mat-tree-node>
    </mat-tree>
  </div>
</ng-container>
